<template>
  <main>
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <div v-if="loading">
            <b-alert show lg="12" md="12" sm="12" variant="light" class="text-center">
              <div class="loader"></div>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="6" sm="12" v-for="item in items" :key="item.id" v-if="item.appnew === 1">
          <!-- notifications in general -->
          <b-card class="border-0 p-0 sm-p-0 rounded one-edge-shadow" :bg-variant="item.id_appointment_status_support === '1' ? 'light' : 'secondary'">
            <b-row>
              <b-col>
                <div class="border-danger text-danger p-2 rounded text-small">
                  <span class="el-icon-date mr-2"></span>
                  <div class="d-inline-block">{{ moment(item.appointment_date).format('DD/MM/YY') }} {{ item.id_times }}</div>
                </div>
                <!-- aflyste/reklamation/etc -->
                <!-- <div class="line-height-golden pl-2" v-if="item.id_appointment_status_support === '1'">
                  <b-button @click="showMeetingDetailsAflysetext(item)" v-if="item.ticketsolution !== ''" variant="link" class="p-0 font-weight-bold text-success">
                    <span class="el-icon-warning-outline float-left mr-2" style="font-size:16px;"></span>
                    {{ item.ticketcategory }}: {{ item.ticketstatus }}
                  </b-button>
                </div> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="text-dark p-2 text-small">
                  <div class="font-weight-bold">Kunde: </div>
                  <div class="">{{ item.firstname }}{{ item.lastname }}</div>
                  <span class="text-small d-inline-block">{{ item.mailingstreet }} {{ item.mailingcity }} {{ item.mailingzip }}</span>
                  <div class="clearfix"></div>
                  <b-button variant="dark" class="my-3 rounded" :href="item.potentialnameurl" target="_blank" v-if="item.potentialnameurl !== ''" >
                  <span class="mr1">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/></svg></span>Prisoverslag</b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="pl-2">
                  <b-btn variant="info" class="rounded mr-3 border-0" v-if="item.id_appointment_status_support === '0' && item.changedate === '1'" @click="showMeetingDetailsDate(item)">
                    <span class="el-icon-refresh-left mr1"></span>
                    Skift dato
                  </b-btn>
                  <b-btn variant="danger" class="rounded border-0" v-if="item.id_appointment_status_support === '0'" @click="showMeetingDetailsAflyse(item)">
                    <span class="el-icon-error mr-1"></span>
                    Aflyse
                  </b-btn>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-modal centered lazy v-model="meetingShow" ref="meetingModal" size="sm">
          <!-- header -->
          <div slot="modal-header" class="w-100 pb-0">
            <div class="py-1"></div>
            <div class="">
              <div class="h5 font-weight-bold">{{ sampleMeeting.type }}</div>
            </div>
          </div>
          <div class="modal-content p-0 border-0">
            <div>
              <span class="text-secondary">By</span>
              <br>
              <span class="h5 font-weight-bold">{{ sampleMeeting.city }}</span> <span class="h5 font-weight-bold">{{ sampleMeeting.postnummer }}</span>
              <br><br>
              <span class="text-secondary">Overslagspris eksl. moms</span>
              <br>
              <span class="h5 font-weight-bold text-red">{{ sampleMeeting.estimate }}</span>
              <br><br>
              <span class="text-secondary">Dato</span>
              <br>
              <span class="h5 font-weight-bold">{{ sampleMeeting.date }}</span>
              <br>
            </div>
          </div>
          <!-- modalFooter -->
          <div slot="modal-footer" class="py-4 d-flex justify-content-end w-100">
            <div><b-btn variant="outline-dark" @click="hideModal">Close</b-btn></div>
          </div>
        </b-modal>
        <b-modal v-model="modalShowAflyseText" hide-footer :title="AflyseTexttitle">
          {{ AflyseText }}
        </b-modal>
        <b-modal id="modalPrevent" hide-footer v-model="modalShowAflyse" ref="modal" :title="Aflysetitle">
          <div slot="modal-header">
            <div class="d-flex flex-row justify-content-between py-2 text-small">
              <p class="h6 font-weight-bold pt-2 text-dark">{{ Aflysetitle }}</p>
              <b-btn variant="outline-dark" slot="modal-close" type="button" class="border-0"><span><i class="el-icon-close"></i></span></b-btn>
            </div>
            <div class="pt-2 open-sans line-height-golden">Hvad skyldes aflysningen af mødet? VIGTIGT: Kunden vil blive kontaktet telefonisk.</div>
          </div>
          <form @submit.stop.prevent="handleSubmitAflyse">
            <b-form-textarea v-model="textAflyseReason" :rows="6" :max-rows="9" required class="textarea rounded border-0"></b-form-textarea>
            <div class="py-2"></div>
            <b-button class="mt-3 rounded float-right" variant="danger" type="submit" :disabled="isLoadingAflyse" size="lg">Submit</b-button>
            <div class="py-2"></div>
          </form>
        </b-modal>
        <b-modal id="modalPrevent" hide-footer v-model="modalShowDato" ref="modal" size="lg" :title="Datosetitle">
          <form @submit.stop.prevent="handleSubmitDato">
            <b-form-row>
              <b-col md="12">
                <b-form-group id="dateStart" label="Dato" label-for="dateStart">
                  <date-picker id="dateStart" v-model="dateDato"   required :config="config"></date-picker>
                </b-form-group>
                <b-form-group label="Vælg tidspunkt" label-for="timeStart">
                  <b-form-select v-model="timeDato" id="select_time" required>
                    <option value="1">00:00</option>
                    <option value="2">00:30</option>
                    <option value="3">01:00</option>
                    <option value="4">01:30</option>
                    <option value="5">02:00</option>
                    <option value="6">02:30</option>
                    <option value="7">03:00</option>
                    <option value="8">03:30</option>
                    <option value="9">04:00</option>
                    <option value="10">04:30</option>
                    <option value="11">05:00</option>
                    <option value="12">05:30</option>
                    <option value="13">06:00</option>
                    <option value="14">06:30</option>
                    <option value="15">07:00</option>
                    <option value="16">07:30</option>
                    <option value="17">08:00</option>
                    <option value="18">08:30</option>
                    <option value="19">09:00</option>
                    <option value="20">09:30</option>
                    <option value="21">10:00</option>
                    <option value="22">10:30</option>
                    <option value="23">11:00</option>
                    <option value="24">11:30</option>
                    <option value="25">12:00</option>
                    <option value="26">12:30</option>
                    <option value="27">13:00</option>
                    <option value="28">13:30</option>
                    <option value="29">14:00</option>
                    <option value="30">14:30</option>
                    <option value="31">15:00</option>
                    <option value="32">15:30</option>
                    <option value="33">16:00</option>
                    <option value="34">16:30</option>
                    <option value="35">17:00</option>
                    <option value="36">17:30</option>
                    <option value="37">18:00</option>
                    <option value="38">18:30</option>
                    <option value="39">19:00</option>
                    <option value="40">19:30</option>
                    <option value="41">20:00</option>
                    <option value="42">20:30</option>
                    <option value="43">21:00</option>
                    <option value="44">21:30</option>
                    <option value="45">22:00</option>
                    <option value="46">22:30</option>
                    <option value="47">23:00</option>
                    <option value="48">23:30</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-textarea v-model="textDatoReason" :rows="6"  :max-rows="9" placeholder="Kommentar" ></b-form-textarea>
            <div class="py-2"></div>
            <b-form-group id="dateStart" label="Send e-mail" label-for="Send Email">
              <toggle-button  v-model="send_email" name="send_email" :sync="true" :labels="true"/>
            </b-form-group>
            <div class="py-2"></div>
            <b-button class="mt-3 rounded" variant="info" block type="submit" :disabled="isLoadingDato" >Submit</b-button>
            <div class="py-2"></div>
          </form>
        </b-modal>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-container>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import datePicker from 'vue-bootstrap-datetimepicker'
export default {
  name: 'newmeetings',
  components: {
    loading,
    Simplert,
    datePicker
  },
  created () {
    this.Reload()
  },
  data () {
    return {
      items: [],
      show: false,
      label: 'Loading...',
      AflyseText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: true,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      salesPerson: '',
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'YYYY-MM-DD',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        // debug: true
        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        // debug: true
        showClear: false,
        showClose: false
      }
    }
  },
  computed: {
    TopItem: function () {
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.array
          },
          response => {
            alert('error')
          }
        )
    },
    handleSubmitDato () {
      this.isLoadingDato = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var emailpartner = 1
      var idTime = $('#select_time').val()
      var time = $('#select_time :selected').text()
      var emailcustomer = this.send_email ? 1 : 0
      var data = {operation: 'change_date', salesPerson: this.salesPerson, appointmentid: this.Datoeid.id_appointment, changedesc: this.textDatoReason, emailcustomer: emailcustomer, datechooseqbook: this.dateDato, id_time: idTime, time: time, emailpartner: emailpartner}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Datoeid.appointment_date = this.dateDato
              this.dateDato = ''
              this.Datoeid.id_times = time
            } else {
              alert(res.message)
              this.isLoadingDato = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    handleSubmitAflyse () {
      this.isLoadingAflyse = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'aflyse', salesPerson: this.salesPerson, appointmentid: this.Aflyseid.id_appointment, aflysedesc: this.textAflyseReason, ticket: 1}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowAflyse = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Aflyseid.id_appointment_status_support = '1'
              this.Aflyseid.ticketsolution = ''
              this.Aflyseid.ticketstatus = 'Afventer behandling'
              this.Aflyseid.ticketcategory = 'Aflysning'
            } else {
              alert(res.message)
              this.isLoadingAflyse = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showMeetingDetailsAflysetext (item) {
      this.modalShowAflyseText = true
      this.AflyseText = item.ticketsolution
      this.AflyseTexttitle = item.ticketstatus
    },
    showMeetingDetailsDate  (item) {
      this.Datosetitle = 'Ændring af tid for kunde: ' + item.firstname + ' ' + item.lastname
      this.modalShowDato = true
      this.Datoeid = item
      this.textDatoReason = ''
      this.isLoadingDato = false
      var select = document.getElementById('select_time')
      for (var i = 0; i < select.length; i++) {
        var option = select.options[i]
        if (option.text === item.id_times) {
          this.timeDato = option.value
        }
      }
    },
    showMeetingDetailsAflyse (item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?'
      this.modalShowAflyse = true
      this.Aflyseid = item
      this.textAflyseReason = ''
      this.isLoadingAflyse = false
    },
    filterItem (items) {
      var newItem = []
      for (var iteme in items) {
        newItem.push(items[iteme])
      }
      return newItem
    },
    showMeetingDetails (item) {
      this.meetingShow = !this.meetingShow
      this.sampleMeeting.id = item.id
      this.sampleMeeting.type = item.type
      this.sampleMeeting.estimate = item.estimate
      this.sampleMeeting.city = item.city
      this.sampleMeeting.postnummer = item.postnummer
      this.sampleMeeting.price = item.price
      this.sampleMeeting.date = item.date
    },
    hideModal () {
      this.$refs.meetingModal.hide()
    }
  }
}
</script>
<style scoped>
.textarea {
  background: #ecf0f1;
}
.card-header {
  border-top: 0;
  border-bottom: 0;
  font-weight: 700;
}
.card-columns > div > .card-header {
}
@media screen and (max-width: 640px) {
  .card {
    min-width: 100%;
    margin-bottom: 24px;
  }
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// MeetingsTable.vue?86fc6782